export default "__VITE_ASSET__r1NrdS12__";